import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DefaultFiltersState } from '@/stores'

import { SetFilterValue } from '../shared.ts'

export interface OperationRequestsTableState extends DefaultFiltersState {}

const initialState: OperationRequestsTableState = {
  page: 0,
  showCount: 10,
}

const operationRequestsSlice = createSlice({
  name: 'operationRequests',
  initialState,
  selectors: {
    filters: (state) => ({ page: state.page, showCount: state.showCount, sort: state.sort }),
  },
  reducers: {
    setFilter: (state, action: PayloadAction<SetFilterValue<OperationRequestsTableState>>) => {
      return {
        ...state,
        page: action.payload.filterKey !== 'page' ? 0 : state.page,
        [action.payload.filterKey]: action.payload.filterValue,
      }
    },
    resetFilters: (state, action: PayloadAction<(keyof OperationRequestsTableState)[]>) => {
      const patch = Object.fromEntries(action.payload.map((key) => [key, initialState[key]]))
      return { ...state, ...patch }
    },
  },
})

export const {
  reducer: operationRequestsReducer,
  selectors: operationRequestsSelectors,
  actions: operationRequestsActions,
} = operationRequestsSlice
